import config from './globals/config';

export default function (leftTrailer, rightTrailer, currentNum) {
  let next, prev;

  prev = currentNum === 0 ? config.max : currentNum - 1;
  next = currentNum === config.max ? 0 : currentNum + 1;

  let trailersJSON = config.featuredTrailersJSON;

  leftTrailer.data({
    'video-id': trailersJSON[prev].bc_trailer_id,
    'position': prev,
  }).find('.text .bottom')
    .text(trailersJSON[prev].post_title);

  rightTrailer.data({
    'video-id': trailersJSON[next].bc_trailer_id,
    'position': next,
  }).find('.text .bottom')
    .text(trailersJSON[next].post_title);
}
